// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '52978e9',
    builtAt: '2026-08-21T12:58:49.989Z',
} as const;
